import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { queryClient } from "@/lib/query-client";
import {
  PERSIST_BUSTER,
  PERSIST_MAX_AGE,
  queryPersister,
} from "@/lib/query-persister";

type Props = {
  children: React.ReactNode;
};

const ReactQueryProvider = ({ children }: Props) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: PERSIST_MAX_AGE,
        buster: PERSIST_BUSTER,
        dehydrateOptions: {
          // `meta: { persist: false }` opts a query out — e.g. the platform
          // certificate status, which carries an expiring signed download link.
          shouldDehydrateQuery: (query) =>{
            return query.state.status === "success" && query.meta?.persist !== false
          }
        },
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
};

export default ReactQueryProvider;
